import axios from "axios";
import API from "./apiInstance";
import PAPI from "./patientsInstance";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const getGraphDataStatus = (props) => {
  const { location_id, account_id } = props;
  
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return PAPI.get(
    `/patients/get-graph-data-status?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getGapsInCareStatus = (props) => {
  const { location_id, account_id } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return API.get(
    `${Config.patientServerUrl}/patients/care-gaps-summary?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getEncounterCount = (props) => {  
  const { location_id, account_id } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
    return axios.get(
      `${Config.apiServerUrl}/patient-encounters/patient/${location_id}/encounter-count?account_id=${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
};

export const getEncounterCountMonthWise = (props) => {
  const { location_id, account_id } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return axios.get(
    `${Config.apiServerUrl}/patient-encounters/patient/${location_id}/encounter-count-month-wise?location_id=${location_id}&account_id=${account_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getEncounterAmountPaidAverage = (props) => {
  const { location_id, account_id, days } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return axios.get(
    `${Config.apiServerUrl}/patient-encounters/patient/${location_id}/encounter-amount-paid-average?account_id=${account_id}&location_id=${location_id}&days=${days}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getEncounterAmountPaidMonthWise = (props) => {
  const { location_id, account_id } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return axios.get(
    `${Config.apiServerUrl}/patient-encounters/patient/${location_id}/encounter-amount-paid-month-wise?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getChargesSubmitted = (props) => {
  const { location_id, account_id } = props;
  if (account_id === 0) {
    return false;
  }
  if (!userAccessToken()) return;
  return axios.get(
    `${Config.apiServerUrl}/patient-encounters/patient/${location_id}/charges-submitted?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getDashboardAppointments = (props) => {
  const { location_id, account_id } = props;
  
  if (account_id === 0) {
    return false;
  }
  // if (!userAccessToken()) return;
  // return PAPI.get(
  //   `/appointments/stats?account_id=${account_id}&location_id=${location_id}`,
  //   {
  //     headers: {
  //       "Content-Type": "application/json",
  //       accept: "application/json",
  //       Authorization: `Bearer ${userAccessToken()}`,
  //     },
  //   }
  // );
  return ({
    data: {
      "confirmed": 1,
      "pending": 7,
      "reschedule": 1,
      "expired": 0,
      "cancelled": 0
    }
  });
};
